import React, { useEffect, useRef, useState } from 'react'
import { ContractStatus } from 'dealer-types'
import Space from '../atoms/Space'
import StatusIcon from './ContractStatusIcon'
import { Text, View } from '../other/html'
import Price from '../molecules/Price'
import LikedSvg from '../other/svg/LikedSvg'
import { useDispatch } from 'react-redux'
import { TOGGLE_LIKED_OFFER } from 'dealer-reducers'
import getScoreColor from 'src/helpers/getScoreColor'
import BuyNowSvg from '../other/svg/BuyNowSvg'
import { useNavigate } from 'react-router-dom'
import track from 'src/helpers/track'
import CountryFlag from '../atoms/CountryFlag'
export const BROWSE_ITEM_MAX_WIDTH = 451
interface Props {
  variant?: 'home' | 'browse'
  label1: string
  label2: string
  buyNowPrice?: number
  buyNowContractId?: number
  highestBet: number
  photo: string | null
  yourHighestBet: number | null
  contractStatus: ContractStatus
  isLiked: boolean
  offerId: number
  score: number
  zipCode: string
  countryCode: string
}

const BrowseItem = ({
  variant = 'browse',
  label1,
  label2,
  photo,
  highestBet,
  yourHighestBet,
  buyNowPrice = 0,
  contractStatus,
  isLiked,
  score,
  offerId,
  zipCode,
  countryCode
}: Props): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const itemRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    setWidth((itemRef.current?.offsetWidth ?? 0) - 80)
  }, [itemRef.current?.offsetWidth])

  return (
    <div className="p-1" ref={itemRef}>
      <View
        className={`pt-2 pb-1 h-[342px] bg-white rounded-4 text-groupBlue shadow-dropBig overflow-hidden max-w-[${BROWSE_ITEM_MAX_WIDTH}px]`}
        onClick={() => {
          navigate(`/browsing/offer/${offerId}`)
        }}>
        <View className="px-2 cursor-pointer relative">
          <View
            className="absolute top-0 left-2 p-1 px-2 text-white rounded-tl-[6px] rounded-br-[6px] font-Bold min-w-9 text-center"
            style={{ backgroundColor: getScoreColor(score) }}>
            {score}
          </View>
          <img
            className="w-full h-[232px] rounded-2 border object-cover"
            src={photo ?? '/assets/images/no_photo@x3.png'}
          />
        </View>
        <View className="flex justify-between px-2">
          <View style={{ width }}>
            <Text className={'text-ellipsis overflow-hidden whitespace-nowrap'} fontSize={20} fontWeight="Bold">
              {label1}
            </Text>
            <Space y={1} />
            <div className={'text-ellipsis text-sm overflow-hidden whitespace-nowrap flex items-center'}>
              {label2}{' '}
              <div className="flex items-center text-foregrounds-fg-subtle">
                &nbsp;| &nbsp; <CountryFlag countryCode={countryCode} /> &nbsp; {zipCode}
              </div>
            </div>
          </View>
          <LikedSvg
            data-testid="like-button"
            className="cursor-pointer pt-1 w-8 h-8"
            variant={isLiked ? 'liked' : 'not_liked'}
            onClick={(e) => {
              e.stopPropagation()
              track('dealer_toggle_liked')
              dispatch(TOGGLE_LIKED_OFFER({ is_liked: isLiked, offer_id: offerId }))
            }}
          />
        </View>
        <View className="flex justify-between pr-2 mt-1">
          <View className="shadow-insetSmall rounded-tr-2 rounded-br-2 flex items-center">
            <StatusIcon contractStatus={contractStatus} />
            {buyNowPrice !== 0 && <BuyNowSvg className="w-9 h-9 mx-2" />}
          </View>
          <Price highestBet={highestBet} yourHighestBet={yourHighestBet} buyNowPrice={buyNowPrice} tilesView />
        </View>
      </View>
    </div>
  )
}

export default BrowseItem
